import { useApiClient } from './ApiClient';

const { post, get } = useApiClient();
const systemId = import.meta.env.VITE_APP_SYSTEMID;

const GuestApi = {
  addGuestUser(mobileId, mobileType) {
    return post(`/users/${systemId}/guest/registration`, { mobileId, mobileType });
  },
  getGuestUser(mobileId) {
    return get(`/users/${systemId}/guest/get`, { mobileId });
  },
};

export default GuestApi;
